var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconKey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.16749 13.6175L6.89249 15.3425M14.8425 11.6975C14.1101 12.428 13.1922 12.9448 12.1877 13.1919C11.1832 13.4391 10.1302 13.4073 9.14249 13.1L5.60999 16.625C5.35499 16.8875 4.85249 17.045 4.49249 16.9925L2.85749 16.7675C2.31749 16.6925 1.81499 16.1825 1.73249 15.6425L1.50749 14.0075C1.45499 13.6475 1.62749 13.145 1.87499 12.89L5.39999 9.36499C4.79999 7.41499 5.26499 5.20249 6.80999 3.66499C9.02249 1.45249 12.615 1.45249 14.835 3.66499C17.055 5.87749 17.055 9.48499 14.8425 11.6975Z",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.875 8.75C11.1734 8.75 11.4595 8.63147 11.6705 8.4205C11.8815 8.20952 12 7.92337 12 7.625C12 7.32663 11.8815 7.04048 11.6705 6.8295C11.4595 6.61853 11.1734 6.5 10.875 6.5C10.5766 6.5 10.2905 6.61853 10.0795 6.8295C9.86853 7.04048 9.75 7.32663 9.75 7.625C9.75 7.92337 9.86853 8.20952 10.0795 8.4205C10.2905 8.63147 10.5766 8.75 10.875 8.75Z",
    stroke: "#808080",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconKey);
export default __webpack_public_path__ + "static/media/iconKey.5f76316498e54b3cf0f9a30c8dd1f340.svg";
export { ForwardRef as ReactComponent };